import React from 'react'
import _ from 'lodash';
import { Menu } from '@headlessui/react';
import { format } from '../../../../../common/services/date.service';
import Map from '../../../../../common/components/map'

export default function JobComponent({ handleShipmentStatusClick, handleMenuClose, handleRejectOpen, anchorShipmentEl, setAnchorShipmentEl, back, jobDetails, getShippingType, getTransporterAgentName, handleShipmentClick, ConvertMinutes }: any) {

 
  const originGps = jobDetails?.PickupInfo?.location?.gps;
  const destinationGps = jobDetails?.DeliveryInfo?.location?.gps;
  const image = require('../../../../../assets/img/delivery.png')
  const latLongData: any = _.split(originGps, ',');
  return (
    <>
      <div className='text-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
      </div>
      <div className="min-h-[450px] w-full  flex flex-col justify-between bg-gray-50 mb-8 py-5 border border-gray-200">

        {originGps && <div className="w-full bg-white px-5 text-gray-800">
        
                 <div className="w-full">
                 <Map
             lat={latLongData[0]}
             lng={latLongData[1]}
             height={'420px'}
             zoom={15}
             icon={image}
             showInfoWindow={false}
             isRouteDirection={true}
             originLocation={originGps}
             destinationLocation={destinationGps}
           />
                 
                 </div>
               </div>}

        <div className="w-full min-h-full flex justify-between flex-col md:flex-row">
          {jobDetails && <div className="px-5 w-1/4 mt-10">
            <div className="mb-10">
              <h3 className="font-bold text-gray-600 text-xl">Order</h3>
            </div>
            <div className="mb-2 text-gray-400">
              <div><span className="text-gray-500 text-sm">Order ID:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.OrderId}</span></div>
              <div>
                <span className="text-gray-500 text-sm">Rap Agent:</span>
                <span className="text-gray-600 text-sm px-2">
                  {`${jobDetails?.RAPAgentAddress?.FirstName || ''} ${jobDetails?.RAPAgentAddress?.LastName || ''}`}
                </span>
              </div>
              <div><span className="text-gray-500 text-sm">Email:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.RAPAgentAddress?.Email}</span></div>
              <div><span className="text-gray-500 text-sm">PhoneNumber:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.RAPAgentAddress?.PhoneNumber}</span></div>
              
            </div>

          </div>}
          <div className="px-5 w-1/4 mt-10">
            <div className="mb-2">
              <h3 className="font-bold text-gray-600 text-xl">Pickup</h3>
            </div>
            {jobDetails?.PickupInfo && <div className="mb-2 text-gray-400">
              {/* <div><span className="text-gray-500 text-sm">Code:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.PickupInfo?.location?.address?.area_code}</span></div> */}
              <div><span className="text-gray-500 text-sm">Name:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.PickupInfo?.location?.address?.name}</span></div>
              <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.PickupInfo?.location?.address?.building} , {jobDetails?.PickupInfo?.location?.address?.locality} ,  {jobDetails?.PickupInfo?.location?.address?.city} , {jobDetails?.PickupInfo?.location?.address?.country} , {jobDetails?.PickupInfo?.location?.address?.state} - {jobDetails?.PickupInfo?.location?.address?.area_code}</span></div>
              <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.PickupInfo?.contact?.name}</span></div>
            </div>}
          </div>
          <div className="px-5 w-1/4 mt-10">
            <div className="mb-2">
              <h3 className="font-bold text-gray-600 text-xl">Delivery</h3>
            </div>
            {jobDetails?.DeliveryInfo && <div className="mb-2 text-gray-400">
              {/* <div><span className="text-gray-500 text-sm">Code:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.DeliveryInfo?.location?.address?.area_code}</span></div> */}
              <div><span className="text-gray-500 text-sm">Name:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.DeliveryInfo?.location?.address?.name}</span></div>
              <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.DeliveryInfo?.location?.address?.building} , {jobDetails?.DeliveryInfo?.location?.address?.locality} ,  {jobDetails?.DeliveryInfo?.location?.address?.city} , {jobDetails?.DeliveryInfo?.location?.address?.country} , {jobDetails?.DeliveryInfo?.location?.address?.state} - {jobDetails?.DeliveryInfo?.location?.address?.area_code}</span></div>
              <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.DeliveryInfo?.contact?.name}</span></div>
            </div>}
          </div>
          {jobDetails?.LogisticsTasks?.length && <div className="px-5 w-1/4 mt-10">
            <div className="mb-2">
              <h3 className="font-bold text-gray-600 text-xl">Tasks</h3>
            </div>

          </div>}

        </div>

      </div>
    </>
  )
}